export default class User{
    constructor(public username: string, public emailSignature: string){
        
    };
}